import api from '@/lib/axios'

export interface LocalizedString {
    tr: string
    [key: string]: string
}

export interface AboutPage {
    id?: string
    _id?: string
    hero: {
        title: LocalizedString
        description: LocalizedString
    }
    stats: {
        value: string
        label: LocalizedString
    }[]
    mainContent: {
        title: LocalizedString
        subtitle: LocalizedString
        description: LocalizedString
        extraDescription: LocalizedString
    }
    values: {
        title: LocalizedString
        description: LocalizedString
        icon?: string
    }[]
    milestones: {
        year: string
        title: LocalizedString
        description: LocalizedString
    }[]
}

export const aboutService = {
    getAboutPage: async () => {
        const res = await api.get<AboutPage>('/about')
        return res.data
    },
    updateAboutPage: async (data: Partial<AboutPage>, translate: boolean = false) => {
        const res = await api.put<AboutPage>('/about', data, { params: { translate } })
        return res.data
    }
}
